import rtk /* , {set, update } */ from 'rtk';
import { name } from './constants';
import { subscribe, unsubscribe } from './actions';
import {
  addEventListener,
  removeEventListeners,
} from '@rails/document/actions';
const { createReducer } = rtk(name);
import { subId } from './selectors';

const initialState = { subscriptions: {}, references: {} };

export const reducer = createReducer(initialState, {
  [addEventListener]: (state, { payload: { uuid, subscription, action } }) => {
    state.subscriptions[subId(subscription)] ??= {
      references: {},
      identifier: null,
    };
    state.subscriptions[subId(subscription)].references[uuid] = action;
    state.references[uuid] ??= {};
    state.references[uuid][subId(subscription)] = true;
  },
  [removeEventListeners]: (state, { payload: { uuid } }) => {
    if (state.references[uuid]) {
      for (const subId of Object.keys(state.references[uuid])) {
        delete state.subscriptions[subId].references[uuid];
      }
      delete state.references[uuid];
    }
  },

  [subscribe.pending]: (state, { meta: { arg: subscription } }) => {
    state.subscriptions[subId(subscription)].identifier = 'pending';
  },
  [subscribe.fulfilled]: (
    state,
    { payload: { identifier }, meta: { arg: subscription } },
  ) => {
    state.subscriptions[subId(subscription)].identifier = identifier;
  },
  [subscribe.rejected]: (state, { meta: { arg: subscription } }) => {
    delete state.subscriptions[subId(subscription)];
  },
  [unsubscribe]: (state, { payload: { identifier } }) => {
    for (const subId of Object.keys(state.subscriptions)) {
      if (state.subscriptions[subId].identifier === identifier) {
        if (Object.values(state.subscriptions[subId].references).length > 0) {
          throw Error('Cant unsubcribe with references !!');
        }
        delete state.subscriptions[subId];
      }
    }
  },
});
